import { Controller } from "@hotwired/stimulus";
import mapboxgl, { Marker } from "mapbox-gl";

export default class extends Controller {
  static targets = ["map", "location"];
  static values = {
    boundingBox: Array,
    color: String,
  };

  connect() {
    console.log("Site guide connected");
    mapboxgl.accessToken =
      "pk.eyJ1IjoibXJ3aWxsaWhvZyIsImEiOiJjbDI5YzRwZzkwMnNwM2NvNGY4aHh4eWR2In0.W4Eu3eTXf7XRC0e5K47zLw";
    this.initMap();
    this.initMarkers();
  }

  initMap() {
    const params = {
      container: this.mapTarget,
      style: "mapbox://styles/mapbox/outdoors-v11",
      attributionControl: false,
      logoPosition: "bottom-right",
    };

    if (this.boundingBoxValue.length > 0) {
      params.bounds = this.boundingBoxValue;
    }

    const map = new mapboxgl.Map(params);

    map.addControl(new mapboxgl.NavigationControl(), "top-right");
    map.addControl(
      new mapboxgl.GeolocateControl({
        showUserLocation: false,
      }),
      "top-right"
    );
    this.map = map;
  }

  initMarkers() {
    this.locationTargets.forEach((location) => {
      const coords = location.dataset.siteGuideLocationParam;
      const name = location.dataset.siteGuideNameParam;
      const description = location.dataset.siteGuideDescriptionParam;
      const url = location.dataset.siteGuideUrlParam;
      const colors = location.dataset.siteGuideColorParam;

      if (coords !== "") {
        const coordsJson = JSON.parse(coords);
        const popup = new mapboxgl.Popup({})
          .setLngLat(coordsJson)
          .setHTML(
            `<div class="p-4">
            <h1 class="text-xl text-gray-900">
              ${name}
            </h1>
            <p class="text-gray-600 text-sm">
              ${description}
            </p>
            <a href="${url}" class="${colors} text-base outline-none">View Site Guide</a>
          </div>
          `
          )
          .setMaxWidth("400px");

        new Marker({
          draggable: false,
          color: this.colorValue,
        })
          .setLngLat(coordsJson)
          .setPopup(popup)
          .addTo(this.map);
      }
    });
  }

  focus(event) {
    event.preventDefault();
    const position = event.params.location;

    this.map.flyTo({
      center: position,
      zoom: 15,
    });
  }
}
